<template>
  <div class="copyright_protection">
    <div class="sheng">
      <div class="m">
        <div class="sheng_tit">
          <h2>各省自助式版权登记入口</h2>
          <p>Self-service copyright registration entrance to each province</p>
        </div>
        <ul class="sheng_content">
          <li>
            <a target="_blank" href="http://www.ahbq.com.cn/bqdj/secondPage.html">
              <img src="@/assets/img/copyright_protection/anhui.png" />
              <h3>安徽省</h3>
              <p>Anhui</p>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="http://banshi.beijing.gov.cn/pubtask/task/1/110000000000/94ab9d2d-7c32-41ac-805c-40d0aff7630e.html?locationCode=110000000000&serverType=1001"
            >
              <img src="@/assets/img/copyright_protection/beijing.png" />
              <h3>北京市</h3>
              <p>Beijing</p>
            </a>
          </li>

          <li>
            <a target="_blank" href="http://bq.cqca.com.cn/intro_2.aspx">
              <img src="@/assets/img/copyright_protection/chongqing.png" />
              <h3>重庆市</h3>
              <p>Chongqing</p>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="http://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?unid=0688C657DE0E5B693B6B85C36A09A1C4&infoType=1"
            >
              <img src="@/assets/img/copyright_protection/fujian.png" />
              <h3>福建省</h3>
              <p>Fujian</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="http://www.gsbqfw.com/user/home-page">
              <img src="@/assets/img/copyright_protection/gansu.png" />
              <h3>甘肃省</h3>
              <p>Gansu</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.hebeibanquan.com.cn">
              <img src="@/assets/img/copyright_protection/hebei.png" />
              <h3>河北省</h3>
              <p>Hebei</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="http://cp.ccct.net.cn/">
              <img src="@/assets/img/copyright_protection/hubei.png" />
              <h3>湖北省</h3>
              <p>Hubei</p>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="http://zzqdj.jssxwcbj.gov.cn:8088/UserServer/userpage/user-login.jsp"
            >
              <img src="@/assets/img/copyright_protection/jiangsu.png" />
              <h3>江苏省</h3>
              <p>Jiangsu</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="http://www.nmcpo.com/">
              <img src="@/assets/img/copyright_protection/neimenggu.png" />
              <h3>内蒙古</h3>
              <p>Nei Mengol</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="http://drmlu.dzwww.com/drmlu/rdgchina/colum?nid=1&id=33">
              <img src="@/assets/img/copyright_protection/shandong.png" />
              <h3>山东省</h3>
              <p>Shandong</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="http://www.shbqdj.cn/#/index">
              <img src="@/assets/img/copyright_protection/shanghai.png" />
              <h3>上海市</h3>
              <p>Shanghai</p>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="http://www.sc-copyright.org/news/article/5e8fbdc9ebf4fc4eb05f210c"
            >
              <img src="@/assets/img/copyright_protection/sichuan.png" />
              <h3>四川省</h3>
              <p>Sichuan</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.tj-copyright.com/">
              <img src="@/assets/img/copyright_protection/tianjin.png" />
              <h3>天津市</h3>
              <p>Tianjin</p>
            </a>
          </li>
          <li>
            <a target="_blank" href="http://www.ynbq.gov.cn/intellectual-project/index.html">
              <img src="@/assets/img/copyright_protection/yunnan.png" />
              <h3>云南省</h3>
              <p>Yunnan</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="gd">
      <div class="m">
        <h3>
          Copyright Registration entry of
          <span>Guangdong Province</span>
        </h3>
        <h4>
          <span>广东省</span>版权登记入口
        </h4>
        <div class="btn" @click="dialogVisible=true">&gt;&gt;&nbsp;&nbsp;报名登记&nbsp;&nbsp;&lt;&lt;</div>
      </div>
    </div>
    <div class="liucheng">
      <div class="m">
        <div class="liucheng_tit">
          <h2>登记流程</h2>
          <p>The registration process</p>
        </div>
        <div class="l_box">
          <div>
            <img src="@/assets/img/copyright_protection/5.png" />
          </div>
          <h3>咨询版权登记</h3>
          <h4>专属顾问1对1服务，给出登记建议及方案</h4>
        </div>
        <div class="l_line"></div>
        <div class="l_box">
          <div>
            <img src="@/assets/img/copyright_protection/1.png" />
          </div>
          <h3>收集申请资料</h3>
          <h4>手机客户登记材料，及时归档并保密</h4>
        </div>
        <div class="l_line"></div>
        <div class="l_box">
          <div>
            <img src="@/assets/img/copyright_protection/2.png" />
          </div>
          <h3>递交给版权局</h3>
          <h4>确认资料并及时递交给版权局申报</h4>
        </div>
        <div class="l_line"></div>
        <div class="l_box">
          <div>
            <img src="@/assets/img/copyright_protection/3.png" />
          </div>
          <h3>版权局审查</h3>
          <h4 style="text-align:center;">进入版权局审查阶段<p style="visibility: hidden;">呵呵</p></h4>
        </div>
        <div class="l_line"></div>
        <div class="l_box">
          <div>
            <img src="@/assets/img/copyright_protection/4.png" />
          </div>
          <h3>得出查询结果</h3>
          <h4>专属顾问定时反馈版权登记进度</h4>
        </div>
      </div>
    </div>
    <div class="feiyong">
      <div class="m">
        <div class="feiyong_tit">
          <h2>登记费用</h2>
          <p>The registration fee</p>
        </div>
        <ul class="feiyong_box">
          <li>
            <h3>普通办理</h3>
            <h4>general</h4>
            <div class="line"></div>
            <h5>
              <span>599</span>元/件
            </h5>
            <h6>30-35个工作日内完成审核，并发证</h6>
            <p>(非办软件类)</p>
            <div class="btn" @click="dialogVisible=true">我要申请</div>
          </li>
          <li>
            <h3>软件类普通办理</h3>
            <h4>general</h4>
            <div class="line"></div>
            <h5>
              <span>1599</span>元/件
            </h5>
            <h6>30-35个工作日内完成审核，并发证</h6>
            <p>(非办软件类)</p>
            <div class="btn" @click="dialogVisible=true">我要申请</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="bq">
      <div class="m">
        <div class="bq_text">
          <h3>版权公证保管</h3>
          <h3>————预防恶意版权抢注</h3>
        </div>
        <div class="btn" @click="dialogVisible2=true">&gt;&gt;&nbsp;&nbsp;报名登记</div>
      </div>
    </div>
    <div class="haochu">
      <div class="m">
        <h2 class="haochu_tit">版权公证保管服务内容</h2>
        <ul class="haochu_content">
          <li class="haochu_item">
            <img src="@/assets/img/copyright_protection/b6.png" />
            <div class="haochu_item_r">
              <h3>预防抢注</h3>
              <p>通过对作品及创作过程的公证保管，预防恶意版权抢注行为；</p>
            </div>
          </li>
          <li class="haochu_item">
            <img src="@/assets/img/copyright_protection/b6.png" />
            <div class="haochu_item_r">
              <h3>有力证明</h3>
              <p>版权公证与版权登记同样能证明版权归属；</p>
            </div>
          </li>
          <li class="haochu_item">
            <img src="@/assets/img/copyright_protection/b6.png" />
            <div class="haochu_item_r">
              <h3>高效办理</h3>
              <p>出证快，最快7个个工作日内拿到《保管证书》；</p>
            </div>
          </li>
          <li class="haochu_item">
            <img src="@/assets/img/copyright_protection/b6.png" />
            <div class="haochu_item_r">
              <h3>公证加持</h3>
              <p>《保管证书》出具单位是准司法机构————公证处，法律效力强！</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="hangai">
      <div class="m">
        <h2 class="hangai_tit">版权公证保管服务内容</h2>
        <ul class="hangai_list">
          <li class="hangai_item">
            <div class="hangai_item_l">01</div>
            <div class="hangai_item_r">
              <h3>出具电子版《电子数据保管与版权声明公证函》</h3>
              <p>用于日常对外公示作品版权归属证明</p>
            </div>
          </li>
          <li class="hangai_item">
            <div class="hangai_item_l">02</div>
            <div class="hangai_item_r">
              <h3>出具纸质版《公证保管证书》</h3>
              <p>可用于打官司。最快7个工作日出证书</p>
            </div>
          </li>
          <li class="hangai_item">
            <div class="hangai_item_l">03</div>
            <div class="hangai_item_r">
              <h3>提供“作品版权维权保险”支持</h3>
              <p>作品被侵权，可凭法院受理通知书获得2000元赔偿</p>
            </div>
          </li>
          <li class="hangai_item">
            <div class="hangai_item_l">04</div>
            <div class="hangai_item_r">
              <h3>提供“维权全程无忧计划”支持</h3>
              <p>协助用户对接经验丰富律师团队，支持维权行动</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="shoufei">
      <div class="m">
        <h2 class="shoufei_tit">版权公证收费</h2>
        <ul class="shoufei_list">
          <li class="shoufei_item">
            <div class="hangai_item_l">
              <h3>电子公证保管服务</h3>
              <p>Electronic notarization custody service</p>
            </div>
            <div class="hangai_item_r">
              50
              <span>元/件</span>
            </div>
          </li>
          <li class="shoufei_item">
            <div class="hangai_item_l">
              <h3>出具纸质版《公证保管证书》</h3>
              <p>Issue a hard copy of the Notarized Storage Certificate</p>
            </div>
            <div class="hangai_item_r">
              300
              <span>元/件</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="kefu">
      <div class="m">
        <div class="kefu_tit">
          <h2>版权保护客服联系</h2>
          <p>Copyright protection customer service contact</p>
        </div>
        <div class="kefu_list">
          <ul class="kefu_l">
            <li>联系方式&nbsp;&nbsp;|&nbsp;&nbsp;扫描二维码添加客服微信号</li>
            <li>客服邮箱&nbsp;&nbsp;|&nbsp;&nbsp;copyright@91ant.com</li>
            <li>工作时间&nbsp;&nbsp;|&nbsp;&nbsp;周一到周五09:00至18:00</li>
            <li>公司地址&nbsp;&nbsp;|&nbsp;&nbsp;中国广东省佛山市南海区桂城瀚天科技A5号楼一号门六楼</li>
          </ul>
          <div class="kefu_r">
            <img src="@/assets/img/copyright_protection/c.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 版权登记 -->
    <copyright_registration :dialogVisible="dialogVisible" @close="close" v-if="dialogVisible" />
    <!-- 版权公证 -->
    <copyright_notarization :dialogVisible="dialogVisible2" @close="close" v-if="dialogVisible2" />
  </div>
</template>

<script>
import copyright_registration from "@/components/dialog/copyright_registration.vue"
import copyright_notarization from "@/components/dialog/copyright_notarization.vue"
export default {
  components:{
    copyright_registration,
    copyright_notarization
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
    };
  },
 
  created() {
    
  },
  methods: {
    close(obj){
      console.log(obj)
      if(obj.name === 'copyright_registration'){
        this.dialogVisible = false;
      }else{
        this.dialogVisible2 = false;
      }
    }
  }
};
</script>

<style lang="scss">
.input-width260{
  width: 260px;
}
.center_dialog {
  .el-dialog__footer {
    text-align: center;
  }
}
.copyright_protection {
  .sheng {
    background: #fff;
    padding: 130px 0 83px;
    .m {
      .sheng_tit {
        text-align: center;
        h2 {
          font-size: 28px;
          font-weight: 700;
          color: #313131;
        }
        p {
          font-size: 16px;
          line-height: 30px;
          color: #9a9a9a;
        }
      }
      .sheng_content {
        margin-top: 43px;
        display: flex;
        flex-wrap: wrap;
        li {
          width: 162px;
          height: 122px;
          margin-bottom: 33px;
          a {
            display: block;
            width: 162px;
            height: 122px;
            text-align: center;
          }
          cursor: pointer;
          img {
            width: 100%;
            height: 83px;
            object-fit: contain;
            object-position: center;
          }
          h3 {
            height: 24px;
            line-height: 24px;
            font-size: 17px;
            color: #000;
          }
          p {
            font-size: 19px;
            color: #919191;
          }
        }
      }
    }
  }

  .gd {
    height: 658px;
    background: url(~@/assets/img/copyright_protection/b2.png) no-repeat center;
    .m {
      text-align: center;
      padding-top: 220px;
      h3 {
        line-height: 39px;
        font-size: 28px;
        color: #fff;
        span {
          color: #0ba1e4;
        }
      }
      h4 {
        line-height: 48px;
        font-size: 34px;
        color: #fff;
        span {
          color: #0ba1e4;
        }
      }
      .btn {
        display: inline-block;
        width: 188px;
        height: 47px;
        line-height: 47px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        background: #0ba1e4;
        cursor: pointer;
        margin-top: 50px;
      }
    }
  }
  .liucheng {
    background: #fff;
    .m {
      padding: 106px 0 125px;
      .liucheng_tit {
        text-align: center;
        h2 {
          color: #313131;
          font-size: 26px;
          font-weight: 600;
        }
        p {
          color: #b4b4b4;
          font-size: 16px;
          margin-top: 10px;
        }
      }
      text-align: center;
      .l_box {
        width: 82px;
        text-align: center;
        display: inline-block;
        margin-top: 46px;
        div {
          width: 88px;
          height: 88px;
          border-radius: 50%;
          background: #e1e1e1;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
          }
        }

        h3 {
          height: 37px;
          line-height: 37px;
          font-size: 13px;
          color: #000;
          margin-top: 14px;
        }
        h4 {
          line-height: 16px;
          font-size: 12px;
          color: #a6a6a6;
        }
      }
      .l_line {
        display: inline-block;
        width: 125px;
        border-bottom: 1px solid dashed;
        color: #c1c1c1;
      }
    }
  }
  .feiyong {
    padding-bottom: 84px;
    background: url(~@/assets/img/copyright_protection/b1.png) no-repeat center;
    .m {
      .feiyong_tit {
        text-align: center;
        padding: 58px 0 50px;
        h2 {
          color: #313131;
          font-size: 26px;
          font-weight: 600;
        }
        p {
          color: #b4b4b4;
          font-size: 16px;
          margin-top: 10px;
        }
      }
      .feiyong_box {
        display: flex;
        justify-content: center;
        li {
          width: 260px;
          padding: 54px 0 40px;
          border: 1px solid #e1e1e1;
          background: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;

          h3 {
            font-size: 18px;
            color: #313131;
          }
          h4 {
            font-size: 18px;
            color: #919191;
            margin-top: 4px;
          }
          .line {
            width: 70px;
            height: 3px;
            margin-top: 8px;
            background: #0ba1e4;
          }
          h5 {
            font-size: 12px;
            color: #757575;
            margin-top: 32px;
            span {
              font-size: 30px;
              font-weight: bold;
              color: #313131;
            }
          }
          h6 {
            font-size: 12px;
            color: #616161;
            line-height: 18px;
            margin-top: 16px;
          }
          p {
            font-size: 12px;
            color: #616161;
            line-height: 18px;
          }
          .btn {
            width: 184px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #fff;
            font-size: 14px;
            background: #0ba1e4;
            cursor: pointer;
            border-radius: 6px;
            margin-top: 54px;
          }
        }
        li:first-child {
          margin-right: 60px;
        }
      }
    }
  }
  .bq {
    background: #fff;
    .m {
      background: url(~@/assets/img/copyright_protection/b4.png) no-repeat 61px
        163px;
      position: relative;
      height: 546px;
      .bq_text {
        position: absolute;
        top: 160px;
        right: 232px;
        h3 {
          font-size: 26px;
          font-weight: 600;
          color: #313131;
        }
        h3 + h3 {
          margin-top: 20px;
        }
      }
      .btn {
        display: inline-block;
        width: 158px;
        line-height: 45px;
        text-align: center;
        cursor: pointer;
        height: 45px;
        color: #fff;
        background: #0ba1e4;
        position: absolute;
        bottom: 108px;
        right: 358px;
      }
    }
  }
  .haochu {
    background: #fff;
    padding-bottom: 117px;
    .m {
      .haochu_tit {
        height: 60px;
        line-height: 60px;
        font-size: 28px;
        color: #313131;
        position: relative;
        font-weight: 600;
      }
      .haochu_tit::after {
        content: "";
        height: 3px;
        width: 36px;
        background: #c1c1c1;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .haochu_content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 53px;
        .haochu_item {
          display: flex;
          width: 50%;
          img {
            width: 73px;
            height: 51px;
            object-position: center;
            object-fit: cover;
          }
          .haochu_item_r {
            margin-left: 30px;
            h3 {
              font-size: 18px;
              line-height: 36px;
              color: #313131;
            }
            p {
              font-size: 12px;
              line-height: 14px;
              color: #a4a4a4;
            }
          }
        }
        .haochu_item:nth-child(n + 3) {
          margin-top: 50px;
        }
      }
    }
  }
  .hangai {
    background: #fff;
    padding-bottom: 100px;
    .m {
      .hangai_tit {
        height: 60px;
        line-height: 60px;
        font-size: 28px;
        color: #313131;
        position: relative;
        font-weight: 600;
      }
      .hangai_tit::after {
        content: "";
        height: 3px;
        width: 36px;
        background: #c1c1c1;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .hangai_list {
        margin-top: 44px;
        background: url(~@/assets/img/copyright_protection/b7.png) no-repeat
          505px 104px;
        .hangai_item {
          display: flex;
          .hangai_item_l {
            height: 43px;
            font-size: 39px;
            border-right: 1px solid #e4e4e4;
            width: 50px;
          }
          .hangai_item_r {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 18px;
            h3 {
              color: #313131;
              font-size: 17px;
              font-weight: 600;
            }
            p {
              color: #999;
              font-size: 12px;
            }
          }
        }
        .hangai_item + .hangai_item {
          margin-top: 38px;
        }
      }
    }
  }
  .shoufei {
    background: #fff;
    padding-bottom: 127px;
    .m {
      .shoufei_tit {
        height: 60px;
        line-height: 60px;
        font-size: 28px;
        color: #313131;
        position: relative;
        font-weight: 600;
      }
      .shoufei_tit::after {
        content: "";
        height: 3px;
        width: 36px;
        background: #c1c1c1;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .shoufei_list {
        width: 1000px;
        display: flex;
        justify-content: space-between;
        margin-top: 36px;
        .shoufei_item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 495px;
          height: 100px;
          border-radius: 6px;
          border: 1px solid #e1e1e1;
          padding: 0 30px 0 25px;
          box-sizing: border-box;
          .hangai_item_l {
            h3 {
              color: #313131;
              font-size: 17px;
              font-weight: 600;
              line-height: 29px;
            }
            p {
              color: #999;
              font-size: 12px;
              line-height: 24px;
            }
          }
          .hangai_item_r {
            font-size: 34px;
            font-weight: 700;
            color: #313131;
            span {
              font-size: 12px;
              font-weight: normal;
              color: #999;
            }
          }
        }
      }
    }
  }
  .kefu {
    background: #fff;
    .m {
      .kefu_tit {
        text-align: center;
        h2 {
          color: #313131;
          font-size: 26px;
          font-weight: 600;
        }
        p {
          color: #b4b4b4;
          font-size: 16px;
          margin-top: 10px;
        }
      }
      .kefu_list {
        margin-top: 25px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 100px;
        .kefu_l {
          li {
            color: #4b4b4b;
            font-size: 14px;
            line-height: 33px;
          }
        }
        .kefu_r {
          padding-top: 20px;
        }
      }
    }
  }
}
</style>